import { Link, useNavigate } from 'react-router-dom'
import { useTheme } from '@mui/material/styles'
import useMediaQuery from '@mui/material/useMediaQuery'
import Box from '@mui/material/Box'
import Tabs from '@mui/material/Tabs'
import Tab from '@mui/material/Tab'
import Select from '@mui/material/Select'
import MenuItem from '@mui/material/MenuItem'

function ResponsiveTabs({ tabs, value }) {
  const theme = useTheme()
  const isDesktop = useMediaQuery(theme.breakpoints.up('md'))
  const navigate = useNavigate()

  if (!isDesktop) {
    return (
      <Box sx={{ borderBottom: 1, borderColor: 'divider', px: 2, py: 1 }}>
        <Select
          value={value}
          onChange={(e) => navigate(tabs[e.target.value].to)}
          fullWidth
          size="small"
        >
          {tabs.map((tab, index) => (
            <MenuItem key={index} value={index}>{tab.label}</MenuItem>
          ))}
        </Select>
      </Box>
    )
  }

  return (
    <Box sx={{ borderRight: 1, borderColor: 'divider', flexShrink: 0, minWidth: 200 }}>
      <Tabs value={value} orientation="vertical">
        {tabs.map((tab, index) => (
          <Tab
            key={index}
            component={Link}
            to={tab.to}
            label={tab.label}
            sx={{ alignItems: 'flex-start' }}
          />
        ))}
      </Tabs>
    </Box>
  )
}

export default ResponsiveTabs
